import { motion } from "framer-motion";
import { Users, Clock, Bell } from "lucide-react";

const pillars = [
  {
    icon: Users,
    tag: "Organize",
    color: "var(--blue)",
    bg: "var(--blue-soft)",
    title: "Sort every contact into groups that match how you actually work.",
  },
  {
    icon: Clock,
    tag: "Remember",
    color: "var(--purple)",
    bg: "var(--purple-soft)",
    title: "Save notes against every person — conversations, promises, context.",
  },
  {
    icon: Bell,
    tag: "Follow up",
    color: "var(--accent)",
    bg: "var(--accent-soft)",
    title: "Get reminded of the right person at the right moment. Every single time.",
  },
];

export default function Pillars() {
  return (
    <section className="relative py-24 md:py-32 border-t border-black/5" data-testid="pillars-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-3 gap-8 md:gap-4">
          {pillars.map((p, i) => (
            <motion.div
              key={p.tag}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="relative"
              data-testid={`pillar-${p.tag.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="flex items-center gap-3 mb-6">
                <span className="text-[color:var(--ink-mute)] text-sm font-mono">0{i + 1}</span>
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ background: p.bg }}
                >
                  <p.icon className="w-4 h-4" style={{ color: p.color }} strokeWidth={2} />
                </div>
                <span className="overline" style={{ color: p.color }}>{p.tag}</span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-medium leading-[1.15] text-[color:var(--ink)] max-w-xs">
                {p.title}
              </h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
